import Vue from 'vue'
import moment from 'moment'
import Vuetify from 'vuetify/lib'
import VueCookie from 'vue-cookie'
import 'vuetify/src/stylus/app.styl'

Vue.use(VueCookie);

Vue.use(Vuetify, {
  iconfont: 'md',
  options: {
    customProperties: true,
  },
  theme: {
    primary: '#C34770',
    secondary: '#444444',
    accent: '#71B2E7',
    background: '#FFF',
  }
})

Vue.filter('formatDate', function(value) {
  if (value) {
    var date = new Date(String(value))
    if (isNaN(date)) {
      return
    }
    return moment(new Date(String(value))).format('DD/MM/YYYY')
  }
});
